import { doHttp } from '../util/common'
import { HTTP_TYPE_GET, HTTP_TYPE_POST } from '../util/constants'

/**
 * 获取贸易行业字典接口
 * @param account
 * @param password
 * @return {*}
 */
export function apiTradeIndustry () {
  let params = {}
  return doHttp('/trade/v1/getSysTradeIndustryList', HTTP_TYPE_POST, params)
}

/**
 * 获取贸易发票类型字典接口
 * @param account
 * @param password
 * @return {*}
 */
export function apiTradeInvoice () {
  let params = {}
  return doHttp('/trade/v1/getSysTradeInvoiceList', HTTP_TYPE_POST, params)
}

/**
 * 获取贸易支付方式字典接口
 * @param account
 * @param password
 * @return {*}
 */
export function apiTradePaycode () {
  let params = {}
  return doHttp('/trade/v1/getSysTradePaycodeList', HTTP_TYPE_POST, params)
}



// WEBPACK FOOTER //
// ./src/api/code.js